/* @flow */

import cond from 'lodash/cond';
import { type VoucherCondicao, type VoucherVisibilidade, type VoucherTipo } from './types';
import label from '../utils/label';
import {
    isUsoUnico,
    isPrimeiraCompra,
    isPrivado,
    isPublico,
    isPorcentagem,
    isValor,
} from './utils';

export const labelVisibilidade: VoucherVisibilidade => string = cond([
    [isPrivado, () => label('Privado', 'primary')],
    [isPublico, () => label('Público', 'brand')],
    [() => true, () => label('Sem visibilidade', 'secondary')],
]);

export const labelCondicao: VoucherCondicao => string = cond([
    [isUsoUnico, () => label('Uso único', 'primary')],
    [isPrimeiraCompra, () => label('Primeira compra', 'brand')],
    [() => true, () => label('Sem condição', 'secondary')],
]);

export const labelTipoValor: VoucherTipo => string = cond([
    [isPorcentagem, tipo => label(tipo, 'primary')],
    [isValor, tipo => label(tipo, 'brand')],
]);
